<template>
  <div>
    <Modal v-model="$parent.tenantListModalShow" :width="600" @on-visible-change="loadList"
      class-name="tenant-list-modal">
      <div slot="header">
        <span>切换租户</span>
      </div>

      <div class="modal-main">
        <div class="list-part">
          <div class="table">
            <div class="table-body">
              <template v-for="item in tList">
                <div :class="['item', item.tenantId == currentTid ? 'active': '']" @click="currentTid = item.tenantId">
                  <div class="left">
                    <div class="able"></div>
                  </div>
                  <div class="name">
                    <span class="omit">{{item.name}}</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer">
        <a class="modal-cancel" @click="$parent.tenantListModalShow = false">取消</a>
        <a class="modal-sure" @click="clickSure">确定</a>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: 'channelList',
    components: {

    },
    data() {
      return {
        currentTid: null,
        tList: []
      };
    },
    filters: {

    },
    computed: {

    },
    methods: {
      loadList(show) {
        if (show) {
          this.currentTid = this.$parent.bsTenantId
          this.tList = JSON.parse(JSON.stringify(this.$parent.tenantList))
        } else {
          this.currentTid = null
          this.tList = []
        }
      },

      clickSure() {
        if (this.currentTid == this.$parent.bsTenantId) {
          this.$parent.tenantListModalShow = false
        } else {
          sessionStorage.setItem('currentTid', this.currentTid)
          window.location.reload()
        }
      },
    }
  };

</script>

<style lang="less" scoped>
  /deep/ .tenant-list-modal {
    .ivu-modal-content {
      .ivu-modal-body {
        padding: 20px;

        .modal-main {
          .list-part {
            .table {
              min-height: 208px;
              max-height: 294px;
              overflow: auto;

              .left {
                width: 40px;
                padding-left: 12px;

                .disable {
                  width: 16px;
                  height: 16px;
                  background: #FFFFFF;
                  border: 6px solid #ccc;
                  border-radius: 50%;
                }

                .able {
                  width: 16px;
                  height: 16px;
                  background: #FFFFFF;
                  border: 1px solid #C0C0C0;
                  border-radius: 50%;
                }
              }

              .name {
                flex: 1;
                width: 0;
              }

              .table-body {
                .item {
                  display: flex;
                  height: 44px;
                  border-radius: 6px;
                  align-items: center;
                  cursor: pointer;

                  &:hover {
                    background: rgba(235, 242, 252, 0.6);
                  }

                  >div {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 14px;
                    color: #333333;
                  }

                  &.active {
                    background: rgba(210, 227, 250, 0.6);

                    .left {
                      .able {
                        border: 6px solid #0B61DB;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    ::-webkit-scrollbar {
      width: 6px;
    }

    ::-webkit-scrollbar-thumb {
      width: 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/common/tenantListModal.vue